import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { copyIcon, likeIcon, dislikeIcon, dislikeRedIcon, downloadIcon } from "assets/icons";
import { likedIcon, shareIcon, speakerIcon } from "assets/icons";
import EmailShare from "../Email";
import Feedback from "../Feedback";
import { dislikeConversation, isLikeConversation } from "services/coversationService";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import * as myconst from "../../constants"
import { handleLoader } from "redux/counterSlice";
import { useDispatch } from "react-redux";
import moment from "moment";

function Actions(props: any) {
    const dispatch = useDispatch();
    const { answer, index, userMessage, handleCopy, handleDownload,
        handleSpeak, handleEmailClick, confirm1, isEmailClicked, notify, stopId, feedbacktext, setAnswer, component
    } = props;
    const [isLike, setLiked] = useState<boolean>()
    const [disLike, setDisLike] = useState(false);
    const [popup, setPopup] = useState(false);
    const [dislikeId, setDislikeId] = useState("")
    const [feedbackcontent, setFeedBackContent] = useState("")
    const [feedback_text, setFeedBackText] = useState(false)
    const params = useParams();

    useEffect(() => {
        setLiked(answer[index]?.ans.rating == "thumbsUp")
        setDisLike(answer[index]?.ans.rating == "thumbsDown")
    }, []);

    // Function to update feedback value
    const updateFeedback = (id: string, newFeedback: string) => {
        setAnswer(answer.map((item: any) => {
            if (item.ans.id === id) {
                return {
                    ...item,
                    ans: {
                        ...item.ans,
                        feedback: newFeedback
                    }
                };
            }
            return item;
        }));
    };

    let featureHistory: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');

    const handleLikeClick2 = async (msgId: any) => {
        try {
            if (!isLike) {
                //let con_id = localStorage.getItem("con_id")
                let con_id = params.id
                const body = {
                    message_id: msgId,
                    conversation_id: con_id,
                    rating: true,
                    text: ""
                }
                const res = await isLikeConversation(body)
                if (res) {
                    setLiked(true)
                    setDisLike(false)
                }

                feedbackcontent && setFeedBackContent("")

            }
            else {
                setLiked(true)
                setDisLike(false)
            }
        } catch (error) {
            toast.error("SOMETHING WENT WRONG", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }

    }

    const handleDisLIke = async (msgId: any, index: any) => {
        setDislikeId(msgId)
        feedbackcontent !== "" && setFeedBackContent(answer[index].ans.feedback)
        try {
            if (!disLike) {
                setDisLike(true)
                setPopup(true)
                // let con_id = localStorage.getItem("con_id")
                let con_id = params.id
                setLiked(false)
                const body = {
                    message_id: msgId,
                    conversation_id: con_id,
                    rating: false,
                    text: ""
                }
                await dislikeConversation(body)
            }
            else {
                setPopup(true)
                setDislikeId(msgId)
                setFeedBackContent(answer[index].ans.feedback)
            }
        } catch (error) {
            toast.error("SOMETHING WENT WRONG", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }


    const handlePopupClosed = async (text: any) => {
        try {
            // dispatch(handleLoader(true));
            setPopup(false)
            //let con_id = localStorage.getItem("con_id")
            let con_id = params.id
            const body = {
                message_id: dislikeId,
                conversation_id: con_id,
                rating: false,
                text: text || ""
            }
            const { result, error } = await dislikeConversation(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            if (result) {
                setDisLike(true)
                setLiked(false)
                // setFeedBackContent(result.content)
                updateFeedback(dislikeId, text);
            }
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const generateConversationContent = (userQuery: any, answer: any) => {
        let conversationContent = '';
        const userQuestion = userQuery;
        const botAnswer = answer;

        conversationContent += `Query : ${userQuestion}\n\nAnswer : ${botAnswer}\n\n`;

        return conversationContent;
    }
    const conversationContent = generateConversationContent(userMessage?.que, answer[index]?.ans.response.output_text);
    const handleShareEmail = () => {
        const emailLink = `mailto:?subject=Conversation%20Content&body=${encodeURIComponent(conversationContent)}`;
        // const blob = new Blob([conversationContent], { type: 'text/plain' });
        // const url = URL.createObjectURL(blob);
        // const emailLink = `mailto:?subject=Conversation%20Content&body=Please%20find%20the%20conversation%20content%20attached&attachment=${url}`;

        window.location.href = emailLink;
        handleEmailClick(index);
    };

    const likeFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.like]
    const dislikeFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.Dislike]
    const copyFlag = featureHistory[myconst?.FEATURE_FLAG_KEY.copy]
    const downloadFlag = featureHistory[myconst?.FEATURE_FLAG_KEY.download]
    const shareFlag = featureHistory[myconst?.FEATURE_FLAG_KEY.share]
    const TextspeechFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.textSpeech]

    return (
        <div className="flex flex-wrap align-items-center w-100 chat-action">
            <div className="flex flex-wrap justify-content-between align-items-center action-date-wrap">
                <div className="conversation-bottom-button-container">
                    {/* <Tooltip id="my-tooltip" /> */}
                    {/* <img className="conversation-section-icon" src={Speaker} alt="speaker-icon" /> */}
                    {(TextspeechFlag === true || TextspeechFlag === undefined) && component !== 'history' && (<span className="conversation-section-icon" onClick={() => handleSpeak(answer[index]?.ans.response.output_text, answer[index]?.ans.id + index)} style={stopId == answer[index]?.ans.id + index ? { backgroundColor: "#F1F1F1", border: "1px solid #404040", borderRadius: "50%" } : {}}><img data-tooltip-id="my-tooltip" data-tooltip-content="Text-to-Speech" title="Text to Speech" src={speakerIcon} alt="speaker-icon" /></span>)}
                    {(copyFlag === true || copyFlag === undefined) && component !== 'history' && (<span className="conversation-section-icon" onClick={(e) => { handleCopy(answer[index]?.ans.response.output_text); confirm1(e) }}><img data-tooltip-id="my-tooltip" data-tooltip-content="Copy" title="Copy" src={copyIcon} alt="copy-button"
                    /></span>)}
                    {(downloadFlag === true || downloadFlag === undefined) && component !== 'history' && (<span className="conversation-section-icon" onClick={() => handleDownload(userMessage.que, answer[index]?.ans.response.output_text)}><img data-tooltip-id="my-tooltip" data-tooltip-content="Download" title="Download" src={downloadIcon} alt="download"
                    /></span>)}

                    {(shareFlag === true || shareFlag === undefined) && component !== 'history' && (<span className="conversation-section-icon" onClick={handleShareEmail}><img data-tooltip-id="my-tooltip" data-tooltip-content="Share" title="Share" src={shareIcon} alt="share" /></span>)}
                    {/* {isEmailClicked[index] && <EmailShare userQuery={userMessage.que} answer={answer[index]?.ans.response.output_text} handleEmailClick={handleEmailClick} index={index} />} */}
                    {(likeFlag === true || likeFlag === undefined) && (<span className="conversation-section-icon" style={{ pointerEvents: component !== 'history' ? 'visible' : 'none' }} onClick={() => handleLikeClick2(answer[index]?.ans.id)}><img data-tooltip-id="my-tooltip" data-tooltip-content="Like" title="Like" src={isLike ? likedIcon : likeIcon} alt="like"
                    /></span>)}

                    {(dislikeFlag === true || dislikeFlag === undefined) && (<span className="conversation-section-icon" style={{ pointerEvents: disLike || component !== 'history' ? 'visible' : 'none' }} onClick={() => { handleDisLIke(answer[index]?.ans.id, index); setFeedBackText(true); }}><img data-tooltip-id="my-tooltip" data-tooltip-content="Dislike" title="Dislike" src={disLike ? dislikeRedIcon : dislikeIcon} alt="dislike"
                    /></span>)}

                </div>
                <div className="response-details">
                    <p className='response-time'>
                        {moment(
                            answer[index]?.ans
                                .created_time
                        ).format(
                            'MMM DD, YYYY HH:mm:ss'
                        )}
                    </p>
                </div>
            </div>
            {/* { */}
            <Feedback handlePopupClosed={handlePopupClosed} feedback_text={feedback_text} setFeedBackText={setFeedBackText} notify={notify} feedbackcontent={feedbackcontent} className="ms-auto" setFeedBackContent={setFeedBackContent} setPopup={setPopup} component={component} />
            {/* } */}

            {/* { */}
            {/* <div className="Feddback-main-div"></div> */}
            {/* } */}
        </div>
    )
}

export default Actions;